import type { TenantUiLabelProfile } from "@madamuh/domain";

export type TenantLabels = {
  lesson: string;
  teacher: string;
  studio: string;
  student: string;
  familyAccount: string;
  enrollment: string;
};

const LABELS_BY_PROFILE: Record<TenantUiLabelProfile, TenantLabels> = {
  dance: {
    lesson: "レッスン",
    teacher: "講師",
    studio: "スタジオ",
    student: "生徒",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  genericLesson: {
    lesson: "レッスン",
    teacher: "講師",
    studio: "会場",
    student: "受講者",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  sports: {
    lesson: "クラス",
    teacher: "コーチ",
    studio: "会場",
    student: "参加者",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  music: {
    lesson: "レッスン",
    teacher: "講師",
    studio: "教室",
    student: "生徒",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  academic: {
    lesson: "授業",
    teacher: "講師",
    studio: "教室",
    student: "受講者",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  },
  art: {
    lesson: "レッスン",
    teacher: "講師",
    studio: "アトリエ",
    student: "生徒",
    familyAccount: "家族アカウント",
    enrollment: "所属"
  }
};

export const GENERIC_TENANT_LABELS: TenantLabels = LABELS_BY_PROFILE.genericLesson;

export function getTenantLabels(profile: TenantUiLabelProfile): TenantLabels {
  return LABELS_BY_PROFILE[profile];
}
